function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.472433,
    height: 60.472449,
    viewBox: "0 0 15.999998 16.000002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.104193 -6.849856)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 13.104194,
    y: 6.849856,
    ry: 2.493144,
    style: {
      fill: "#60725b",
      strokeWidth: 0.264583,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#afe9af",
      fillOpacity: 1
    },
    transform: "translate(-1.13544 -.641389) scale(1.0456947)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.394505,
    height: 11.126437,
    x: 22.359381,
    y: 9.680352,
    ry: 0.794746,
    style: {
      fill: "#afe9af",
      strokeWidth: 0.426625,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.394505,
    height: 6.900215,
    x: -11.892037,
    y: 20.723352,
    ry: 0.492873,
    style: {
      fill: "#afe9af",
      strokeWidth: 0.335969,
      fillOpacity: 1
    },
    transform: "rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#afe9af",
      fillOpacity: 1
    },
    transform: "translate(-1.13544 -.641389) scale(1.0456947)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.394505,
    height: 11.126437,
    x: -19.999365,
    y: -20.844713,
    ry: 0.794746,
    style: {
      fill: "#afe9af",
      strokeWidth: 0.426625,
      fillOpacity: 1
    },
    transform: "scale(-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.359589,
    height: 5.7244,
    x: -18.810236,
    y: 9.609819,
    rx: 1.179795,
    ry: 1.085523,
    style: {
      fill: "#afe9af",
      strokeWidth: 0.303769,
      fillOpacity: 1
    },
    transform: "matrix(-.3380741 -.9411195 .91092024 -.4125825 0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a776e1b626d7f577fe7f8d93036077db.svg";
export { ForwardRef as ReactComponent };